import { render, staticRenderFns } from "./OperaCouponWindow.vue?vue&type=template&id=cca17b20&scoped=true&"
import script from "./OperaCouponWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCouponWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCouponWindow.vue?vue&type=style&index=0&id=cca17b20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca17b20",
  null
  
)

export default component.exports